import AMapLoader from '@amap/amap-jsapi-loader';
import { aMapKey } from '@/common/components/config-v2';

const GEOCODE_TIMEOUT = 10000;

/** 仅解析来源地址，不创建地图；地区、商圈及区域保护仍交给原有表单联动。 */
export const resolveFranchiseeAddress = (address: string, mapConfig?: any): Promise<any> => {
  // 当前 mapConfig 仅影响地图展示，不用于覆盖全站 SDK 的 key/version。
  void mapConfig;
  if (typeof address !== 'string' || !address.trim()) {
    return Promise.reject(new Error('地址为空'));
  }

  return new Promise((resolve, reject) => {
    let finished = false;
    const finish = (result?: any) => {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      if (result) resolve(result);
      else reject(new Error('地址解析失败'));
    };
    // 插件或服务未回调也必须结束，避免一直占用初始化状态。
    const timer = setTimeout(() => finish(), GEOCODE_TIMEOUT);

    const geocode = (AMap: any) => {
      if (finished) return;
      if (typeof AMap?.Geocoder !== 'function') {
        finish();
        return;
      }
      const coder = new AMap.Geocoder({ city: '全国', batch: false });
      coder.getLocation(address, (status: string, result: any) => {
        const first = result?.geocodes?.[0];
        const { lng, lat } = first?.location || {};
        if (status !== 'complete' || !Number.isFinite(lng) || !Number.isFinite(lat) ||
          lng < -180 || lng > 180 || lat < -90 || lat > 90) {
          finish();
          return;
        }
        finish({
          lng,
          lat,
          name: address,
          cityName: typeof first.city === 'string' && first.city ? first.city : first.province,
          poiId: null,
          identification: 'basicAddress',
        });
      });
    };

    // 已有 SDK 优先通过插件机制复用，避免切换现有 key/version。
    Promise.resolve().then(async () => {
      const existing = window.AMap;
      if (existing) {
        if (typeof existing.Geocoder === 'function') geocode(existing);
        else if (typeof existing.plugin === 'function') {
          existing.plugin(['AMap.Geocoder'], () => {
            try {
              geocode(existing);
            } catch {
              finish();
            }
          });
        } else finish();
        return;
      }
      const AMap = await AMapLoader.load({
        key: aMapKey,
        version: '2.0',
        plugins: ['AMap.Geocoder'],
      });
      geocode(AMap);
    }).catch(() => finish());
  });
};

